import styled from "styled-components"

import {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"

export const StyledRouterLink = styled(RouterLink)`
  path {
    fill: ${({theme}) => theme.colors.greys.white};
  }
  &:hover {
    path {
      fill: ${({theme}) => theme.colors.greys.white};
    }
  }
`

export const BlueCircle = styled(Flex)`
  background-color: ${({theme}) => theme.colors.primary1};
  width: 24px;
  height: 24px;
  border-radius: 100px;
`
